import { Model } from './model';

interface DisputeStatuses {
  proposed: number;
  in_process: number;
  needs_review: number;
  resolved: number;
  closed: number;
  open_dispute_create_tasks: number;
}

export class DisputeStatusCount extends Model {
  dispute_statuses: DisputeStatuses;

  get proposed() {
    return this.dispute_statuses?.proposed || 0;
  }

  get in_process() {
    return this.dispute_statuses?.in_process || 0;
  }

  get needs_review() {
    return this.dispute_statuses?.needs_review || 0;
  }

  get resolved() {
    return this.dispute_statuses?.resolved || 0;
  }

  get closed() {
    return this.dispute_statuses?.closed || 0;
  }

  get open_dispute_create_tasks() {
    return this.dispute_statuses?.open_dispute_create_tasks || 0;
  }

  get inactive() {
    return this.proposed + this.open_dispute_create_tasks;
  }
}
